import { Space, Tag } from 'antd';
import { AccountStatusLabel } from 'src/models';

import * as Styles from './AccountStatusTag.styles';

interface AccountStatusTagProps {
  label: AccountStatusLabel;
}

export const AccountStatusTag = ({ label }: AccountStatusTagProps) => (
  <Tag className={Styles.tag(label)}>
    <Space direction='horizontal' size={8}>
      {label}
    </Space>
  </Tag>
);
